// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ncLgupkhPNit1w0VMAKq {
  height: 100%;
  grid-template-rows: 10% 1fr;
  grid-template-columns: auto;
  grid-template-areas: "nav" "page";
}`, "",{"version":3,"sources":["webpack://./src/pages/App/App.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCACA;AAAJ","sourcesContent":[".App {\n    height: 100%;\n    grid-template-rows: 10% 1fr;\n    grid-template-columns: auto;\n    grid-template-areas: \n    \"nav\"\n    \"page\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `ncLgupkhPNit1w0VMAKq`
};
export default ___CSS_LOADER_EXPORT___;
